<template><div class="home">

<v-layout row justify-center class="mx-2 my-5">
	<v-flex xs12 sm10 md8 lg6 px-2>
		<div class="text-h4 text-center pa-5"> {{ 'Transliterations' | t }} </div>

		<p> {{ $t('When writing foreign words...') }} </p>

		<div class="d-flex">
		<v-select class="mb-4 flex" style="max-width: 400px"
			v-model="input_lang"
			:items="language_list"
			menu-props="auto"
			:label="$t('Select the language')"
			hide-details
			:prepend-icon="$mdi.Translate"
			single-line
			@change="change_page()"
		/>
		</div>

		 <div v-if="rules">
		 	<p> Here are the non-obvious correspondences between Nao and {{ language }}: </p>

		 	<div v-if="$vuetify.breakpoint.xs">
		 		<div class="my-3" v-for="row in rules">
		 			<div class="font-weight-bold">
		 				<span v-html="row[0].replace('<br>','')"> </span>
		 				<span class="px-2"> → </span>
		 				<span class="main_color" v-html="row[1].replace('<br>','')"> </span>
		 			</div>

		 			<div v-for="e in row[3]">
			      		<span v-html="e.orig"> </span> →
			      		<span class="NOWRAP">
			      			<span v-html="e.nao_html"> </span>
			      			<v-btn class="speaker_button" @click="$nao.pronounce($nao.disassemble(e.nao))" icon><v-icon small> {{ $mdi.VolumeHigh }} </v-icon></v-btn>
			      		</span>
			      	</div>
			      	<v-divider></v-divider>
		 		</div>
		 		
		 	</div>

			<v-simple-table v-else class="mb-4">
			<template v-slot:default>
			  <thead>
			    <tr>
			      <th> {{ language | t }} </th>
			      <th> Nao </th>
			      <th> {{ "Example" | t }} </th>
			    </tr>
			  </thead>
			  <tbody>
			    <tr v-for="row in rules">
			      <td v-html="row[0]">  </td>
			      <td v-html="row[1]">  </td>
			      <td>
			      	<span v-if="false" class="font-weight-medium" v-html="row[2]"> </span>
			      	<div v-for="e in row[3]">
			      		<span v-html="e.orig"> </span> →
			      		<span class="NOWRAP">
			      			<span v-html="e.nao_html"> </span>
			      			<v-btn class="speaker_button" @click="$nao.pronounce($nao.disassemble(e.nao))" icon><v-icon> {{ $mdi.VolumeHigh }} </v-icon></v-btn>
			      		</span>
			      	</div>
			      	
			      </td>
			    </tr>
			  </tbody>
			</template>
			</v-simple-table>
		</div>

		<div v-if="language == 'Mandarin'">
			<p class="text-h5 text-center"> Initials </p>
			<Awtable :arr="string_to_object( tr.Mandarin.initials )"/>
			<p class="text-h5 text-center"> Finals </p>
			<Awtable :arr="string_to_object( tr.Mandarin.finals )"/>
			<p class="text-h5 text-center"> Comparison with pinyin </p>
			<p> Here are the differences between Nao transliteration and pinyin (official transliteration for Mandarin Chinese): </p>
			<Awtable :arr="string_to_object( tr.Mandarin.pinyin )"/>
		</div>

		<div v-else-if="language == 'Cantonese'">
			<p class="text-h5 text-center"> Initials </p>
			<Awtable nohead :arr="string_to_object( tr.Cantonese.initials )"/>
			<p> * omitted if the final starts with the same vowel, e.g. 益 ik, 粵 iut, 碗 un </p>
			<p class="text-h5 text-center"> Finals </p>
			<Awtable nohead :arr="string_to_object( tr.Cantonese.finals )"/>
		</div>

		<div v-if="examples"> 
			<p> Here are some examples from {{ language }}: </p>

			<v-simple-table class="mb-4">
			<template v-slot:default>
			  <thead>
			    <tr>
			      <th> {{ language }} </th>
			      <th> Nao </th>
			      <th v-if="examples[0].length == 3"> English </th>
			    </tr>
			  </thead>
			  <tbody>
			    <tr v-for="row in examples">
			    	<td> {{ row[0] }} </td>
			    	<td> <nao pronounce :o="row[1]"/>  </td>
			    	<td v-if="row[2]"> {{ row[2] }} </td>
			    </tr>
			  </tbody>
			</template>
			</v-simple-table>
		</div>

		<div v-if="$nao.transliteration_languages.includes(language)">
			<p> Below you can transliterate any word from {{language}} to Nao: </p>
			<v-layout>
			    <v-text-field
			        dense filled disable
		        	rounded solo dense clearable
					:placeholder="translit_placeholder"
					@keydown.enter="set_word"
					v-model="translit_input"
					@click:clear="clear()"
					:append-icon="$mdi.Magnify"
					@click:append="set_word"
		        />
		    </v-layout>

		    <p class="text-center" v-if="word_to_translit.length > 0 && translit_result">
		    	{{word_to_translit}} → <nao pronounce :o="translit_result"/> 
		    </p>
		</div>

	</v-flex>
</v-layout>
</div></template>

<script>
import Awtable from '@/components/Awtable'
import nao from '@/components/Naoword'

// <v-btn @click="$nao.pronounce($nao.disassemble(row[2]))" icon><v-icon> mdi-volume-high </v-icon></v-btn>

function compare_objects(field) {
	return function (a,b) {
	    let fa = a[field].toLowerCase(),
	        fb = b[field].toLowerCase();

	    if (fa < fb) return -1;
	    if (fa > fb) return 1;
	    return 0;
	}
}

function string_to_object(s) {
	return s.trim().split(/\n+/).map(line => line.split(/\t+/) ) ;
}

let domain = "https://transliterations.herokuapp.com";

export default {
	components: {Awtable, nao},
	data() {
		return {
			input_lang: '',
			translit_input: '',
			word_to_translit: '',
			translit_result: null
		}
	},
	watch: {
		async word_to_translit() {
			this.translit_result = await this.transliterate_extended(this.language, this.word_to_translit);
		}
	},
	methods: {
		string_to_object,
		change_page() {
			this.$router.push('/transliterations/' + this.input_lang).catch(err => {});
			this.clear();
		},
		set_word() {
			this.word_to_translit = this.translit_input;
		},
		clear() {
			this.word_to_translit = '';
			this.translit_input = '';
		},
		async transliterate_extended(lang, w) {
			if (lang == 'Japanese') {
				let response = await fetch(domain + '/translit_japanese?text=' + w );
				w = (await response.json()).sentence;
				return this.$nao.transliterate_to_Nao('Japanese_hepburn', w);
			}
			else if (lang == 'Mandarin') {
				let response = await fetch(domain + '/translit_mandarin?text=' + w );
				w = (await response.json()).sentence;
				return this.$nao.transliterate_to_Nao('Chinese_pinyin', w);
			}
			else return this.$nao.transliterate_to_Nao(lang, w);
		}
	},
	computed: {
		rules() {
			function make_red(s) {
				return s.replace(/\[(.+?)\]/g, '<span class="marked">$1</span>');
			}

			if (!this.language || !this.tr[this.language].rules) return null;
			let res = string_to_object(this.tr[this.language].rules);

			for (let line of res) {
				if (line[2].trim().length == 0) continue;
				line.push(line[2].split('<br>').map(function(x) {
					//console.log(x);
					let f = x.match(/(.+)→\s+('.+)$/);
					if (!f) return {};
					return {orig: make_red(f[1]), nao: f[2].trim().replace(/\[|\]/g, ''), nao_html: make_red(f[2]) };
				}));
				line[2] = line[2].replace(/\[(.+?)\]/g, '<span class="marked">$1</span>');
			}
			return res;
		},
		examples() {
			if (!this.language || !this.tr[this.language].examples) return null;
			return string_to_object(this.tr[this.language].examples);
		},
		language() {
			return this.input_lang = this.$route.params.lang;
		},
		translit_placeholder() {
			return 'Type a word in ' + this.language;
		},
		/*
		translit_result() {
			this.$nao.transliterate_to_Nao(this.language, this.word_to_translit);
		},
		*/
		language_list() {
			return Object.keys(this.tr).map(item => ({value: item, text: this.$t(item) }) ).sort(compare_objects('text'));
		}
	},
	created() {
		this.tr = {
Belarusian: {
rules:`
Ж			j 		[Ж]лобін → '[j]lobin
х			h 		Бы[х]аў → 'by[h]au
г			g 		Салі[г]орск → 'sali[g]orsk
ц <br> (before hard vowels)		ts 		Слу[ц]к → 'slu[ts]k
ц <br> (before soft vowels)		t 		Ві[ц]ебск → 'vi[t]ebsk
дз <br> (before soft vowels)	d  		Жо[дз]іна → 'jo[d]ina <br> [Дз]мітрый → '[d]mitryi
ч			tc 		Рэ[ч]ыца → 're[tc]ytsa
е, э		е 		Алякс[е]й → 'aliaks[e]i <br> Андр[э]й → 'andr[e]i
ё 			io  	Магіл[ё]ў → 'magil[io]u 
ь			−		Гомел[ь] → 'gomel
ы 			y 		Маз[ы]р → 'maz[y]r
ю 			iu 		[Ю]рась → 'iuras
я  			ia 		[Я]гор → '[ia]gor
й, '  		i  		Бабру[й]ск → 'babru[i]sk <br> Вараб[']ёў → 'varab[i]iou
`,
examples:
`
Мінск			'minsk		Minsk
`},

Bulgarian: {
rules:`
и, й	i		Пана[й]отов → 'pana[i]otov
я, ю, ьо		ia, iu, io		Софи[я] → 'sofi[ia]
щ		ct		Търгови[щ]е → 'tyrgovi[ct]e
ж		j		Наде[ж]да → 'nade[j]da
ц		ts		Вра[ц]а → 'vra[ts]a
ч		tc		Добри[ч] → 'dobri[tc]
ъ		y		Сл[ъ]нчев бряг → 'sl[y]ntcev-briag
`,
examples:
`
Варна		'varna			Varna
Пловдив		'plovdiv		Plovdiv
Ванчев		'vantcev		Vanchev`
},


Cantonese:{
initials:`
巴 b		怕 p		媽 m		花 f		
打 d		他 t		那 n		啦 l
家 g		卡 k		牙 ng	蝦 h		
瓜 gu	誇 ku	蛙 u *	沙 s	
渣 j		叉 tc	也 i *
`,

finals:`
沙 aa	徙 aai		梢 aau		三 aam		山 aan		坑 aang		圾 aap		剎 aat		客 aak
_		西 ai		收 au		心 am		新 an		生 ang		十 ap		失 at		塞 ak
些 e		四 ei		掉 eu		舐 em		_			鄭 eng		夾 ep		_			石 ek
詩 i		_			消 iiu		閃 im		先 in		星 ing		攝 ip		洩 it		識 ik
疏 o		開 oi		蘇 ou		_			看 on		康 ong		_			喝 ot		索 ok
夫 u		灰 ui		_			_			寬 un		鬆 ung		_			闊 ut		叔 uk
鋸 y		需 yi		_			_			詢 yn		商 yng		_			摔 yt		削 yk
書 iu	_			_			唔 m			孫 iun		吳 ng		_			雪 iut		_
`,
examples:
`
九龍		'gaulung		Kowloon
尖沙咀	'jimsaajyi		Tsim Sha Tsui
上水		'syngsyi		Sheung Shui
青衣		'tcing-i		Tsing Yi
小西灣	'siiusai-uan	Siu Sai Wan
荔枝角	'laijigok		Lai Chi Kok
沙田		'saatin			Sha Tin
馬鞍山	'maaonsaan		Ma On Shan
屯門		'tiunmun		Tuen Mun
大埔		'daaibou		Tai Po
深水埗	'samsyibou		Sham Shui Po
`},

Czech: {
rules:`
j, i, y		i		[J]an → '[i]an
ě		ie		Prost[ě]jov → 'prost[ie]iov
ů		u		Jirk[ů] → 'iirk[u]
h		g		Pra[h]a → 'pra[g]a
ch		h		Vojtě[ch] → 'voitie[h]
c		ts		Libere[c] → 'libere[ts]
š		c		Tomá[š] → 'toma[c]
ž		j		Tou[ž]im → 'tou[j]im
č		tc		[Č]eské Budějovice → '[tc]eske-budieiovitse
ň, ť, ď <br>before a vowel		ni, ti, di		Slati[ň]any → 'slati[ni]ani <br> Horaž[ď]ovice → 'goraj[di]ovitse
ň, ť, ď <br>in other cases		n, t, d			Třebo[ň] → 'trebo[n] <br> Třeš[ť] → 'trec[t]
ř		r		Dvo[ř]ák → 'dvo[r]ak
l, r <br>between<br>consonants		yl, yr		P[l]zeň → 'p[yl]zen <br> B[r]no → 'b[yr]no
`,
examples:
`
Ostrava				'ostrava
Hradec Králové		'gradets-kralove
Ústí nad Labem		'usti-nad-labem
`},

Dutch: {
rules:`
double consonant		single consonant		Ro[tt]erdam → 'ro[t]erdam
g			g		[G]elderland → '[g]elderland
h, ch		h		[H]aag → '[h]aag <br> S[ch]agen → 's[h]agen
v, w		v		[V]enlo → '[v]enlo <br> [W]ageningen → '[v]ageningen
z			z		[Z]eeland → '[z]eeland
sj			c		
double vowel		preserve		H[aa]rlem → 'h[aa]rlem
i, ie		i		Fr[ie]sland → 'fr[i]sland
ij, ei		ei		Over[ij]ssel → 'over[ei]sel <br> [Ei]ndhoven → '[ei]ndhoven
uw + vowel		v + vowel		Lee[uwa]rden → 'lee[va]rden
oe, uw		u		C[oe]vorden → 'k[u]vorden <br> Nie[uw]egein → 'ni[u]egein
u			u		Limb[u]rg → 'limb[u]rg
uu			iu		
eu			io		H[eu]sden → 'h[io]sden
ui			aiu		Maassl[ui]s → 'maasl[aiu]s
au, ou		au		H[ou]ten → 'h[au]ten
vowel reduced to /ə/		preserve the vowel		Ap[e]ldoorn → 'ap[e]ldoorn
y, j		i		[J]an → '[i]an <br> Am[y] → 'am[i]
en		en <br>(always)		Antwerp[en] → 'antverp[en]
`},

English: {
rules:`
/æ/, /ɑ/		a		J[a]ck → 'j[a]k <br> Ch[a]rlotte → 'c[a]rlot
/ɔ/, /ɔ:/		o		[Au]stin → '[o]stin <br> B[o]ston → 'b[o]ston
unstressed vowel reduced to <br>/ə/ or /ɪ/		Preserve the vowel		[A]tlant[a] → '[a]tlant[a] <br> Los Ang[e]l[e]s → 'los-anj[e]l[e]s <br> Leicest[e]r → 'lest[e]r
ia reduced to /ə/		a		Felic[ia] → 'felic[a] <br> Christ[ia]n → 'kristc[a]n <br> Georg[ia] → 'jorj[a]
Two or more unstressed vowels reduced to <br>/ə/ or /ɪ/		y		Plym[ou]th → 'plim[y]t
/ɪ/, /i:/		i		[I]nd[i]anapol[i]s → '[i]nd[i]anapol[i]s <br> Ph[oe]n[i]x → 'f[i]n[i]ks
/aɪ/		ai		M[i]ami → 'm[ai]ami
/eɪ/		ei		M[ai]ne → 'm[ei]n
/ɔɪ/		oi		Illin[oi]s → 'ilin[oi]
/ɔʊ/ from two consecutive letters		ou		Sn[ow]den → 'sn[ou]den <br> Wind[ow]s → 'uind[ou]z
/ɔʊ/ from one letter		o		[O]hi[o] → '[o]hai[o] <br> R[o]se → 'r[o]z
/aʊ/		au		Gregory H[ou]se → 'gregori 'h[au]s
/ʌ/ from letter u		y		Kent[u]cky → 'kent[y]ki
/ʌ/ from letter o		o		L[o]ndon → 'l[o]ndon
/ʊ/,/jʊ/ <br>from u/ew<br>after n,l,t,d,s		u		N[ew] York → 'n[u]-iork
letter r		r		Califo[r]nia → 'kalifo[r]nia
/θ/		t		[Th]eodore → '[t]iodor
/ð/		d		Sou[th]wark → 'sy[d]ark
/w/		u		[W]ilson → '[u]ilson
/ŋ/		ng		Washi[ng]ton → 'uoci[ng]ton
/j/		i		[U]tah → '[iu]ta
/ær/, /ɛr/ from ar		ar		H[ar]ry → 'h[ar]i <br> South C[ar]olina → 'saut-k[ar]olaina
/ɛər/		er		Delaw[ar]e → 'delau[er]
`,

examples: `
Massachusetts	'masatcusets
Missouri		'mizuri
New Mexico		'nu-meksiko
Chicago			'cikago
Columbus		'kolymbus
Vancouver		'vankuver
Manchester		'mantcester
Cambridge		'kambrij
Facebook		'feisbuk
Google			'gugl
Youtube			'iutub
`},

Finnish: {
rules:`
j		i		[J]ulia → '[i]ulia
a,ä		a		H[ä]meenlinn[a] → 'h[a]meenlinn[a]
o,ö		o		Närpi[ö] → 'narpi[o]
y		y		[Y]löjärvi → '[y]loiarvi
`,

examples: `
Helsinki	'helsinki
Nokia		'nokia
Turku		'turku
Tampere		'tampere
`},

French: {
rules:`
/ʁ/			r		Pa[r]is → 'pa[r]i
/o/,/ɔ/		o		Lim[o]ges → 'lim[o]j <br>  Bord[eau]x → 'bord[o]
/ɛ/,/e/		e		Saint-Naz[ai]re → 'sen-naz[e]r <br> L'Or[é]al → 'lor[e]al
/ə/, /ø/, /œ/		y		R[e]nault → 'r[y]no <br> P[eu]geot → 'p[y]jo
/ɛ̃/			en		R[eim]s → 'r[en]s
/ɑ̃/			an		Présid[en]t → 'prezid[an]
/õ/			on		Ly[on] → 'li[on]
/y/,/ɥ/		iu		Airb[u]s → 'erb[iu]s
/u/, /w/	u		T[ou]l[ou]se → 't[u]l[u]z <br> Tr[oy]es → 'tr[ua] <br> R[ou]en → 'r[u]an
/i/,/j/		i		Versa[ill]es → 'versa[i] <br> Poit[i]ers → 'puat[i]e
/ɲ/			ni		Co[gn]ac → 'ko[ni]ak
`,

examples: `
Montréal		'monreal
Québec			'kebek
Marseille		'marsei
Nice			'nis
Nantes			'nant 
Leroy Merlin	'lyrua-merlen
Carrefour		'karfur
Citroën 		'sitroen 
Auchan			'ocan
Christian Dior	'kristian-dior
Chanel			'canel
Moët & Chandon	'moet-e-candon
`},

German: {
rules:`
double consonant (pronounced as a single one)		single consonant		Bo[nn] → 'bo[n]
dt <br>(syllable final)		t		Schmi[dt] → 'cmi[t]
v		f		Hanno[v]er → 'hano[f]er
w		v		[W]ien → '[v]in
r		r		F[r]ankfu[r]t → 'f[r]ankfu[r]t
sch		c		Bo[sch] → 'bo[c]
h (before vowels), ch		h		Mi[ch]ael → 'mi[h]ael
z, tz		ts		Ben[z] → 'ben[ts]
st, sp <br> (pronounced with "sch")		ct, cp		[St]uttgart → '[ct]utgart <br> [Sp]ielberg → '[cp]ilberg
s (in other cases), ß <br>		s		Dre[s]den → 'dre[s]den
ie		i		S[ie]mens → 's[i]mens
ei		ai		[Ei]nst[ei]n → '[ai]nct[ai]n
eu		oi		[Eu]ler → '[oi]ler
ä, ö, ü		?, io, iu		M[ü]nchen → 'm[iu]nhen <br> K[ö]ln → 'k[io]ln
j		i		[J]ohann → '[i]ohan
`,

examples: `
Berlin			'berlin
Leipzig			'laiptsig
Zürich			'tsiurih
Nürnberg		'niurnberg
Volkswagen		'folksvagen
Schwarzkopf		'cvartskopf
Hamburg			'hamburg
Friedrich Nietzsche		'fridrih 'nitsce
Johann Sebastian Bach	'iohan 'sebastian 'bah
Sigmund Freud			'sigmund 'froid
Werner Heisenberg		'verner 'haisenberg
Ludwig van Beethoven	'ludvig 'fan-bethofen
`},

Greek: {
rules:`
double consonant		single consonant		Σέ[ρρ]ες → 'se[r]es
η, ει, οι		i		[Η]ράκλ[ει]ο → '[i]rakl[i]o
θ		t		[Θ]εσσαλονίκη → '[t]esaloniki
αι		e		[Αι]κατερίνη → '[e]katerini
ου		u		Αντωνί[ου] → 'antoni[u]
ω		o		Ι[ω]άννινα → 'i[o]anina
γι (before vowel)			i		[Γι]άννης → '[i]anis <br> Πανα[γι]ώτης → 'pana[i]otis
αυ, ευ		av, ev		Μ[αυ]ρίδης → 'm[av]ridis <br> Λ[ευ]κάδα → 'l[ev]kada
υ (in other cases)	i		Κέρκ[υ]ρα → 'kerk[i]ra
b		v		[Β]ασίλης → '[v]asilis
χ		h		Μι[χ]άλης → 'mi[h]alis
γγ		ng		Ευά[γγ]ελος → 'eva[ng]elos
μπ		mp		Καλα[μπ]άκα → 'kala[mp]aka
ντ		nt		Κωνστα[ντ]ίνα → 'konsta[nt]ina
γκ		nk		Λα[γκ]αδάς → 'la[nk]adas
`,

examples: `
Αθήνα		'atina		Athens
Τρίπολη		'tripoli	Tripoli
Μακεδονία	'makedonia	Macedonia
Κρήτη		'kriti		Crete
Πυθαγόρας	'pitagoras	Pythagoras
Σωκράτης	'sokratis	Socrates
Αριστοτέλης	'aristotelis	Aristotle
`},

Italian: {
rules:`
double consonants		(single consonant)		Fe[rr]ari → 'fe[r]ari
sci, ci, gi <br>before a vowel		c, tc, j		pro[sci]utto → 'pro[c]uto
sci, ci, gi <br> in other cases		ci, tci, ji		Fibonac[ci] → 'fibona[tci]
sce, ce, ge		ce, tce, je		Versa[ce] → 'versa[tce]
ch, gh		k, g		Lambor[gh]ini → 'lambor[g]ini
s		s (always)		parme[s]an → 'parme[s]an <br> [s]barro → '[s]baro
gn		ni		'lasa[gn]a → 'lasa[ni]a
gli		li		Ca[gli]ari → 'ka[li]ari
h		(none)		
z		ts		piz[z]a → 'pi[ts]a
`,

examples: `
Venezia		'venetsia
Brescia		'breca
Milano		'milano
Sicilia		'sitcilia
Gucci		'gutci
Nutella		'nutela 
Dolce & Gabbana		'doltce-e-gabana
Prada		'prada
`},

Japanese: {
rules:`
し、しゃ、しゅ、しょ		ci, ca, cu, co		四国 → [し]こく → '[ci]koku
ち、ちゃ、ちゅ、ちょ		tci, tca, tcu, tco	千葉 → [ち]ば → '[tci]ba
じ、じゃ、じゅ、じょ		ji, ja, ju, jo		富士 → ふ[じ] → 'fu[ji]
ざ、ず、ぞ、ぜ			za, zu, zo, ze		銀座 → ぎん[ざ] → 'gin[za]
ふ、ふぁ、ふぇ、ふぉ、ふぃ	fu, fa, fe, fo, fi	[ファ]ッション → '[fa]ccon
ら行					r					スバ[ル] → 'suba[ru]
つ					tsu					コタ[ツ] → 'kota[tsu]
わ					ua					川崎 → か[わ]さき → 'ka[ua]saki
や/ゃ、よ/ょ、ゆ/ゅ、いぇ		ia, io, iu, ie		[ヤ]マハ → '[ia]maha
[ou] or [oo] as a part of the same kanji/root		o		北海道 → ほっかい[どう] → 'hokkai[do] <br> 大阪 → [おお]さか → '[o]saka
[uu] as a part of the same kanji/root		u		九州 → き[ゅう]し[ゅう] → 'ki[u]c[u]
ん		n		群馬 → ぐ[ん]ま → 'gu[n]ma
ー (長音記号)		(ignored)		セーラー服 → 'serafuku
っ				repeat the [first] consonant		札幌 → さ[っぽ]ろ → 'sa[ppo]ro <br> 抹茶 → ま[っちゃ] → 'ma[ttca]
`,

examples: `
東京		'tokio		Tokyo
京都		'kioto		Kyoto
神戸		'kobe		Kobe
日立		'hitatci	Hitachi
三菱		'mitsubici	Mitsubishi
柔術		'jujutsu	Jiu-jitsu
柔道		'judo		Judo
`},

Korean: {
rules:`
ㅂ (initial)		b		배 → 'be
ㅂ (final)		p		엽 → 'iop
ㅍ		p		편 → 'pion
ㄱ (initial)		g		강 → 'gang
ㄱ (final)		k		박 → 'bak
ㅋ		k		커 → 'ko
ㄷ (initial)		d		담 → 'dam
ㄷ,ㅅ,ㅆ,ㅈ,ㅊ (final)		t		
ㅌ		t		탁 → 'tak
ㅁ		m		문 → 'mun
ㄴ		n		남 → 'nam
ㅎ		h		해 → 'he
ㅅ		s		산 → 'san
ㅈ		j		주 → 'ju
ㅊ		tc		천 → 'tcon
ㄹ		l		를 → 'lyl
ㅇ (final)		ng		흥 → 'hyng
ㅣ		i		인 → 'in
ㅔ,ㅐ		e		대 → 'de
ㅓ		o		거 → 'go
ㅏ		a		산 → 'san
ㅡ		y		읍 → 'yp
ㅜ		u		울 → 'ul
ㅗ		ou		도 → 'dou
ㅚ , ㅞ , ㅙ		ue		회 → 'hue
ㅟ , ㅢ		ui		귀 → 'gui
ㅘ		ua		과 → 'gua
ㅝ		uo		뭐 → 'muo
ㅑ , ㅠ , ...		ia, iu, ...		양 → 'iang
`,

examples: `
서울		'so-ul			Seoul
평양		'piong-iang		Pyongyang
대구		'degu			Daegu
광주		'guangju		Gwangju
부산		'busan			Busan
김		'gim			Kim
이		'i				Lee
박		'bak			Park/Pak
장		'jang			Chang/Jang
현우		'hion-u			Hyun-woo / Hyeon-woo
서연		'so-ion			Seo-yeon
지혜		'jihie			Ji-hye
민규		'mingiu			Min-kyu
하은		'hayn			Ha-eun
`},

Malay: {
rules:`
y		i			[Y]og[y]akarta → '[i]og[i]akarta
w		u			Singka[w]ang → 'singka[u]ang
c		tc			[C]imahi → '[tc]imahi
e		e (always)		T[e]rnat[e] → 't[e]rnat[e]
`,

examples: `
Kuala Lumpur		'kuala-lumpur
Jakarta				'jakarta
Java				'java
`},

Mandarin: {
initials:`
Character with initial	注音		Nao transliteration
八		ㄅ		b
杷		ㄆ		p
馬		ㄇ		m
法		ㄈ		f
地		ㄉ		d
提		ㄊ		t
你		ㄋ		n
利		ㄌ		l
告		ㄍ		g
考		ㄎ		k
好		ㄏ		h
叫		ㄐㄧ		dzi
巧		ㄑㄧ		tsi
小		ㄒㄧ		si
知		ㄓ		j
吃		ㄔ		tc
是		ㄕ		c
日		ㄖ		r
字		ㄗ		dz
詞		ㄘ		ts
四		ㄙ		s
`,

finals: `
Character with final	注音		Nao transliteration
阿		ㄚ		a
可		ㄜ		e
台		ㄞ		ai
黑		ㄟ		ei
猫		ㄠ		ao
口		ㄡ		ou
反		ㄢ		an
忙		ㄤ		ang
们		ㄣ		en
冷		ㄥ		eng
书		ㄨ		u
化		ㄨㄚ		ua
波,罗	ㄛ,ㄨㄛ	uo
快		ㄨㄞ		uai
水		ㄨㄟ		uei
团		ㄨㄢ		uan
黄		ㄨㄤ		uang
顿		ㄨㄣ		uen
龙		ㄨㄥ		ong
翁		ㄨㄥ		ueng
西		ㄧ		i
家		ㄧㄚ		ia
别		ㄧㄝ		ie
鸟		ㄧㄠ		iao
六		ㄧㄡ		iou
片		ㄧㄢ		ian
强		ㄧㄤ		iang
民		ㄧㄣ		in
星		ㄧㄥ		ing
熊		ㄩㄥ		iong
女		ㄩ		iu
学		ㄩㄝ		iue
全		ㄩㄢ		iuan
均		ㄩㄣ		iun
十		(none)	y
`,

pinyin:`
Pinyin		Nao		Example
x			s		下 sia
q, c		ts		切 tsie , 菜 tsai
j, z		dz		京 dzing , 作 dzuo
sh			c		书 cu
ch			tc		成  tceng
zh			j		周 jou
w, wu		u		五 u , 外 uai
y, yi		i		英 ing , 也 ie
zi, shi,...		dzy, cy,...		四 sy, 日 ry
ü			iu		区 tsiu, 学 siue
ui			uei		会 huei
iu			iou		六 liou
un			uen		村 tsuen
`,

examples: `
北京		'beidzing		Beijing
上海		'canghai		Shanghai
广州		'guangjou		Guangzhou
台湾		'tai-uan		Taiwan
台北		'taibei			Taipei
西安		'si-an			Xi'an
四川		'sytcuan		Sichuan
高雄		'gaosiong		Kaohsiung
青岛		'tsingdao		Qingdao
小米		'siaomi			Xiaomi
魅族		'meidzu			Meizu
`},

Polish: {
rules:`
sz		c		Toma[sz] → 'toma[c]
cz		tc		Bie[cz] → 'bie[tc]
ż		j		[Ż]ywiec → '[j]yviets
prz, krz		pc,kc		[Krz]ysztof → '[kc]yctof
trz, drz		tyc,dyj		An[drz]ej → 'an[dyj]ei
rz (in other cases)		j		Wałb[rz]ych → 'vaub[j]yh <br> Cho[rz]ów → 'ho[j]uv
si		ci		[Si]edlce → '[ci]edltse
ś		c		Przemy[ś]l → 'pcemy[c]l
ci		tci		Mar[ci]n → 'mar[tci]n
ć		tc		Zamoś[ć] → 'zamoc[tc]
dzi		ji		[Dzi]wnów → '[ji]vnuv
dź		j		Czela[dź] → 'tcela[j]
zi		zi		[Zi]elona Góra → '[zi]elona-gura
ź		z		Rogo[ź]no → 'rogo[z]no
ń		n		Gda[ń]sk → 'gda[n]sk
ó		u		Krak[ó]w → 'krak[u]v
c		ts		Katowi[c]e → 'katovi[ts]e
ł		u		Wroc[ł]aw → 'vrots[u]av 
y		y		Olszt[y]n → 'olct[y]n
j		i		[J]anusz → '[i]anuc
ę		en		Cz[ę]stochowa → 'tc[en]stohova
ą		on		G[ą]bin → 'g[on]bin
`,

examples: `
Warszawa		'varcava
Bydgoszcz		'bydgoctc
Poznań			'poznan
Szczecin		'ctcetcin
Łódź			'uuj
Białystok		'biauystok
Rzeszów			'jecuv
Trzcianka		'tyctcianka
`},

Russian: {
rules:`
ж		j		Вороне[ж] → 'vorone[j]
ц		ts		Липе[ц]к → 'lipe[ts]k
ч		tc		[Ч]ита → '[tc]ita
ш		c		[Ш]арапова → '[c]arapova
щ, щи	ci		[Щ]укино → '[ci]ukino
е, э	е		[Е]л[е]на → '[e]l[e]na
ё		o (after ж,ш,щ,ч) <br> io (otherwise)		Горбач[ё]в → 'gorbatc[o]v <br> П[ё]тр → 'p[io]tr 
ь		i (before vowel) <br> − (otherwise)		Вороб[ь]ёв → 'vorob[i]iov  <br> Твер[ь] → 'tver
ъ		—		
ы		y		С[ы]кт[ы]вкар → 's[y]kt[y]vkar
ю		iu		Т[ю]мень → 't[iu]men
я		ia		Бр[я]нск → 'br[ia]nsk
й		i		Толсто[й] → 'tolsto[i]
жи, ши		jy, cy		Бала[ши]ха → 'bala[cy]ha <br> Дзер[жи]нск → 'dzer[jy]nsk
`,

examples: `
Москва				'moskva				Moscow
Санкт-Петербург		'sankt-peterburg	Saint Petersburg
Чайковский			'tcaikovskii		Tchaikovsky
Хрущёв				'hruciov			Khrushchev
`},

Slovak: {
rules:`
j, i, y		i		[J]án → '[i]an
h		g		[H]umenné → '[g]umenne
ch		h		Vojte[ch] → 'voite[h]
c		ts		Koši[c]e → 'koci[ts]e
š		c		Tomá[š] → 'toma[c]
ž		j		[Ž]ilina → '[j]ilina
č		tc		Tren[č]ín → 'tren[tc]in
ň, ľ, ť, ď <br>before a vowel		ni, li, ti, di		Stará [Ľ]ubovňa → 'stara-[li]ubovnia <br>  Pieš[ť]any → 'piec[ti]ani
ň, ľ, ť, ď <br>in other cases		n, l, t, d		Topo[ľ]čany → 'topo[l]tcani <br> Sere[ď] → 'sere[d]
l, r <br>between<br>consonants		yl, yr		T[r]nava → 't[yr]nava
ô		o		-
`,

examples: `
Bratislava		'bratislava
Prešov			'precov
`},

Spanish: {
rules:`
z		s		[Z]arago[z]a → '[s]arago[s]a <br> Bar[c]elona → 'bar[s]elona
b,v		b		[V]alencia → '[b]alensia <br> [B]ogotá → '[b]ogota
y, ll	i		Gua[y]aquil → 'gua[i]akil <br> [Ll]eida → '[i]eida
h		−		Chi[h]ua[h]ua → 'tciuaua
j		h		San [J]osé → 'san-[h]ose <br> [G]i[j]ón → '[h]i[h]on
ñ		ni		Logro[ñ]o → 'logro[ni]o
`,

examples: `
Madrid			'madrid
Guatemala		'guatemala
Buenos Aires	'buenos-aires
Puerto Rico		'puerto-riko
mojito			'mohito
burrito			'burito
`},

Turkish: {
rules:`
y		i		Antal[y]a → 'antal[i]a
u,ü		u		Atat[ü]rk → 'atat[u]rk
o,ö		o		K[ö]rfez → 'k[o]rfez
ı		y		 Diyarbak[ı]r → 'diiarbak[y]r
ş		c		Eski[ş]ehir → 'eski[c]ehir
ç		tc		[Ç]orum → '[tc]orum
c		j		Ko[c]aeli → 'ko[j]aeli
ğ <br> between vowels 		(ignore)		Erdo[ğ]an → 'erdoan
ğ <br> in other cases		(double the previous vowel) 		Tekird[ağ] → 'tekird[aa] 
circumflex <br>on vowels		(ignore)		El[â]zığ → 'el[a]zyy
`,

examples: `
İstanbul	'istanbul
Ankara		'ankara 
`},

Ukrainian: {
rules:`
и			y		Сум[и] → 'sum[y]
і, ї, й		i		Р[і]вне → 'r[i]vne
я, ю		ia, iu	Вінниц[я] → 'vinnyts[ia]
є			e		[Є]впаторія → '[e]vpatoriia
ь, '		−		Л[ь]вів → 'lviv
х			h		[Х]ерсон → '[h]erson
г, ґ		g		Черні[г]ів → 'tcerni[g]iv
щ			ctc		[Щ]астя → '[ctc]astia
`,

examples: `
Київ		'kyiv			Kyiv
Кривий Ріг	'kryvyi-rig		Kryvyi Rih
Одеса		'odesa			Odesa
Харків		'harkiv			Kharkiv
`},

Vietnamese: {
rules:`
a, ă		a		Đ[à] N[ẵ]ng → 'd[a]n[a]ng
â, ơ		y		C[ầ]n Th[ơ] → 'k[y]nth[y]
e, ê		e		Bi[ê]n Hòa → 'bi[e]nhoa
o, ô		o		Bả[o] L[ộ]c → 'ba[o]l[o]k
u, ư		u		Th[ừ]a Thiên–H[u]ế → 'th[u]athienh[u]e 
i,y			i		Thá[i] Ngu[y]ên → 'tha[i]ngu[i]en
tr			j		Nha [Tr]ang → 'nia[j]ang 
ch (initial)		tc		Hồ [Ch]í Minh → 'ho[tc]iming
ph			f		Hải [Ph]òng → 'hai[f]ong
th			th		Phan [Th]iết → 'fan[th]iet
kh			kh		[Kh]ánh Hòa → '[kh]ainghoa
nh (initial), <br> nhi		ni		Qui [Nh]ơn → 'kui[ni]yn <br> [Nhi]ếp → '[ni]ep
ng			ng		[ng]a[ng] → '[ng]a[ng]
đ			d		[Đ]à Lạt → '[d]alat
r			r		Bà [R]ịa → 'ba[r]ia
d, gi		z		Hải [D]ương → 'hai[z]uyng
c,k,q		k		Phú [Q]uố[c] → 'fu[k]uo[k]
s			c		[S]ông Cầu → '[c]ongkyu
x			s		Long [X]uyên → 'long[s]uien
anh, ach	aing, aik		Th[anh] Hóa → 'th[aing]hoa <br> R[ạch] Giá → 'r[aik]za
ênh, êch	eng, ek		Phạm M[ệnh] → 'famm[eng]
inh, ich	ing, ik		Tây N[inh] → 'tyin[ing] <br> Th[ích] → 'th[ik]
silent h <br> after g		(none)		Ng[h]ệ An → 'ngean
`,

examples: `
Hà Nội		'hanoi
Vũng Tàu	'vungtau
Nguyễn		'nguien
Trần		'jyn
Phạm		'fam
`}
		}
	},
}
</script>

<style>

.marked {
	color: red;
}

</style>